import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    product: graphql(`
        fragment isProductOf_Product on Product {
            __typename
            code
        }
    `),
}

export function isProductOf(
    fragment: FragmentOf<typeof graphQLFragments.product>,
    productCode: string | string[]
) {
    const product = readFragment(graphQLFragments.product, fragment)

    return typeof productCode === "string"
        ? product.code === productCode
        : productCode.includes(product.code)
}

isProductOf.fragments = graphQLFragments
